import React, { useState } from 'react';
import DocumentService from './../services/DocumentService';
import NotificationService from './../services/NotificationService';
import './../styles/AdminPage.css';
import { useAuth } from './../context/AuthContext';

function AdminPortal() {
  const [docFileName, setDocFileName] = useState('');
  const [docTitle, setDocTitle] = useState('');
  const [docType, setDocType] = useState('');
  const [docFile, setDocFile] = useState(null);

  const [notifFileName, setNotifFileName] = useState('');
  const [notifTitle, setNotifTitle] = useState('');
  const [notifDescription, setNotifDescription] = useState('');
  const [notifFile, setNotifFile] = useState(null);
  const handleDocSubmit = async (e) => {
    e.preventDefault();

    try {
      await DocumentService.uploadDocument(docFileName, docTitle, docType, docFile);
      alert('Document uploaded successfully');
      setDocFileName('');
      setDocTitle('');
      setDocType('');
      setDocFile(null);
    } catch (error) {
      console.error('There was an error uploading the document!', error);
    }
  };

  const handleNotifSubmit = async (e) => {
    e.preventDefault();

    try {
      await NotificationService.uploadNotification(notifFileName, notifTitle, notifDescription, notifFile);
      alert('Notification uploaded successfully');
      setNotifFileName('');
      setNotifTitle('');
      setNotifDescription('');
      setNotifFile(null);
    } catch (error) {
      console.error('There was an error uploading the notification!', error);
    }
  };

  return (
    <div className="admin-portal">
      <h2>Upload Document</h2>
      <form onSubmit={handleDocSubmit}>
        <div className="admin-form-group">
          <label htmlFor="docFileName">File Name</label>
          <input
            type="text"
            id="docFileName"
            value={docFileName}
            onChange={(e) => setDocFileName(e.target.value)}
            required
          />
        </div>
        <div className="admin-form-group">
          <label htmlFor="docTitle">Title</label>
          <input
            type="text"
            id="docTitle"
            value={docTitle}
            onChange={(e) => setDocTitle(e.target.value)}
            required
          />
        </div>
        <div className="admin-form-group">
          <label htmlFor="docType">Type</label>
          <select
            id="docType"
            value={docType}
            onChange={(e) => setDocType(e.target.value)}
            required
          >
            <option value="">Select Type</option>
            <option value="Mac">Mac</option>
            <option value="Windows">Windows</option>
            <option value="Chrome">Chrome</option>
            <option value="Android">Android</option>
          </select>
        </div>
        <div className="admin-form-group">
          <label htmlFor="docFile">File</label>
          <input
            type="file"
            id="docFile"
            onChange={(e) => setDocFile(e.target.files[0])}
            required
          />
        </div>
        <button type="submit">Upload Document</button>
      </form>

      <h2>Upload Notification</h2>
      <form onSubmit={handleNotifSubmit}>
        <div className="admin-form-group">
          <label htmlFor="notifFileName">File Name</label>
          <input
            type="text"
            id="notifFileName"
            value={notifFileName}
            onChange={(e) => setNotifFileName(e.target.value)}
            required
          />
        </div>
        <div className="admin-form-group">
          <label htmlFor="notifTitle">Title</label>
          <input
            type="text"
            id="notifTitle"
            value={notifTitle}
            onChange={(e) => setNotifTitle(e.target.value)}
            required
          />
        </div>
        <div className="admin-form-group">
          <label htmlFor="notifDescription">Description</label>
          <input
            type="text"
            id="notifDescription"
            value={notifDescription}
            onChange={(e) => setNotifDescription(e.target.value)}
            required
          />
        </div>
        <div className="admin-form-group">
          <label htmlFor="notifFile">File</label>
          <input
            type="file"
            id="notifFile"
            onChange={(e) => setNotifFile(e.target.files[0])}
            required
          />
        </div>
        <button type="submit">Upload Notification</button>
      </form>
    </div>
  );
}

export default AdminPortal;
